import { generateRouteConfigs, generateRoutesObject } from "./utils";
import { getRegistry } from "./route-registry";
import type { RouteConfig } from "./types";
import type { ProtectedRoutesMap } from "./protected/protected-routes";
import type { PublicRoutesMap } from "./public-routes";

// Import route files to trigger registration (side-effect imports)
// These must be imported before reading the registry
import "./protected/protected-routes";
import "./public-routes";

// Get the registry (routes are now registered)
const registry = getRegistry();

// Generate route objects with proper type inference
const protectedRoutesObject = generateRoutesObject(registry.protected);
const publicRoutesObject = generateRoutesObject(registry.public);

// Auto-generate routes object for type-safe navigation
// Only includes routes defined as Record<string, RouteType> format
// Use the type map for better autocomplete and type checking
export const routes: ProtectedRoutesMap & PublicRoutesMap = {
  ...protectedRoutesObject,
  ...publicRoutesObject,
} as ProtectedRoutesMap & PublicRoutesMap;

// Auto-generate RouteConfig[] arrays for wouter routing
export const protectedRoutes: RouteConfig[] = generateRouteConfigs(
  registry.protected
);

export const publicRoutes: RouteConfig[] = generateRouteConfigs(
  registry.public
);
